// extracted by mini-css-extract-plugin
module.exports = {"xs":"320","sm":"390","md":"768","lg":"1128"};